import { get, post } from './https';

export const GetEnquiry = async ({
  page = 1,
  limit = 25,
  searchQuery = '',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
}) => {
  let url = `/api/v1/admin/enquiry-list?limit=${limit}&page=${page}&type=OLD_AC`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch taxation');
  }
};

export const EnquiryDetail = async (id: string) => {
  const url = `${process.env.REACT_APP_SERVER_API_BASE_URL}/api/v1/admin/enquiry/${id}`;
  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch booking details');
  }
};

export const CreateEnquiry = async (payload: Record<string, any>) => {
  const response = await post('/api/v1/admin/enquiry/create', payload);

  if (response.status === 201 || response.status === 200) {
    return response.data;
  }

  throw new Error(response?.data?.message || 'Failed to create request');
};

export const AssignInspector = async (
  enquiryId: string,
  technicianId: string,
  assignmentType: string,
): Promise<number> => {
  const url = `${process.env.REACT_APP_SERVER_API_BASE_URL}/api/v1/admin/enquiry/assign_technician`;
  const response = await post(url, {
    enquiryId,
    technicianId,
    assignmentType,
  });
  if (response.status == 200) {
    return 200;
  } else {
    throw new Error('Failed to Assign Technician to Booking');
  }
};

export const SubmitEnquiryOffer = async (payload: Record<string, any>) => {
  const response = await post('/api/v1/admin/enquiry/submit-offer', payload);

  if (response.status === 200 && response.data?.status) {
    return response.data;
  }

  throw new Error(response?.data?.message || 'Failed to submit quotation');
};

